
import React, { useState, useEffect } from 'react';
import './styleUpdatingOptic.css';
import CustomSnackbar from '../Optics/Components/CustomSnackbar';
import { Snackbar } from '@mui/material';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import {Button} from '@mui/material';
import { SearchRegionOptic } from './LoadingDataOptic';
import ModalUpdatingOptic from './ModalUpdatingOptic';

const UpdatingOptic = (user) => {

    const { showSnackbar, snackbarOpen, handleCloseSnackbar, snackbarMessage, snackbarClass } = CustomSnackbar();
    const [region, setRegion] = useState('');
    const [optics, setOptics] = useState([]);
    const [houses, setHouses] = useState([]);
    const [error, setError] = useState('');
    const [selectedCable, setSelectedCable] = useState(null); 
    const [openVewingModal,  setOpenVewingModal] = useState(false); 
    const [searchQuery, setSearchQuery] = useState("");

    const filteredOptics = optics.map(optic => {
        const matchingRows = optic.rows.filter(row =>
          row.area && String(row.area).trim() !== '' &&
          (searchQuery === '' || String(row.area).includes(searchQuery))
        );
        return matchingRows.length > 0 ? { ...optic, matchingRows } : null;
      }).filter(Boolean);

    const searchOptic = async () => {
        SearchRegionOptic(region, setOptics,setHouses, setError);
        setSearchQuery('');
        
    };
    const handleRowClick = (cable) => {
       setSelectedCable(cable);
       setOpenVewingModal(true);
    };

    useEffect(() => {
            SearchRegionOptic(region, setOptics, setHouses, setError); 
    }, [openVewingModal]);

    const copyToClipboard = (text) => {
        const textarea = document.createElement("textarea");
        textarea.value = text;
        document.body.appendChild(textarea);
        textarea.select();
        textarea.focus(); 
        try {
          const successful = document.execCommand("copy");
          if (successful) {
            showSnackbar('Скопировано: ID: ' + text, 'snackbarOk');
          } else {
            showSnackbar('Не удалось скопировать ID в буфер обмена', 'snackbarError');
          }
        } catch (err) {
          showSnackbar('Не удалось скопировать ID в буфер обмена', 'snackbarError');
        }
        document.body.removeChild(textarea);
      };
     
    const totalAddresses = filteredOptics.length;
    const totalActualized = filteredOptics.filter(address => address.status).length;
    const totalNoCoordinates = totalAddresses - totalActualized;

    return (
      <div className="updating-territory">
      <h3 style={{color: "#a1a1a1", fontSize: "20px" , textShadow: '2px 2px 4px #000000'}}>Актуализация оптики</h3>
      <div className="flex-container">
          <div>
              <input
                  className='inputAuth'
                  type="number"
                  placeholder="введите регион"
                  value={region}
                  onChange={(e) => setRegion(e.target.value)}
              />
              <button className='buttonLogin' onClick={searchOptic}>Поиск</button>
              
          </div>
          <div className="address-summary">
            <label style={{color: "#c5c5c5", textShadow: '2px 2px 4px #242424'}}>Всего оптики: <span style={{color: "orange"}}>{totalAddresses}.</span></label>
            <label style={{color: "#c5c5c5" , textShadow: '2px 2px 4px #242424', marginLeft: "10px"}}>Актуализировано: <span style={{color: "#71fc64"}}>{totalActualized}.</span></label>
            <label style={{color: "#c5c5c5", textShadow: '2px 2px 4px #242424', marginLeft: "10px"}}>Нет фото: <span style={{color: "#fc7664"}}>{totalNoCoordinates}.</span></label>
          </div>
          <input 
                type="number" 
                placeholder="поиск по веткам" 
                value={searchQuery} 
                className='textInputPoiskModal'
                onChange={(e) => setSearchQuery(e.target.value)} 
                style={{ marginLeft: '20px' }}
            />
        
      </div>
      <hr className='horizontalLine12Modal'/>
            {error && <p style={{ color: '#e9d7d7' }}>{error}</p>}
            {filteredOptics.length > 0 && (
            <div className="table-container1" style={{marginTop:'10px'}}>
                <table className="address-table1" >
                    <thead>
                        <tr>
                            <th>ID</th>             
                            <th>Округ</th>
                            <th>Регион</th>
                            <th>Ветка</th>
                            <th>Тип</th>
                            <th>Марка</th>
                            <th>Длина</th>
                            <th>Start</th>
                            <th>End</th>
                            <th>Коммент</th>
                            <th>Создал</th>
                            <th>Статус</th>
                        </tr>
                    </thead>
                    <tbody>
                   
        {filteredOptics.map((optic, index) => {
             const firstRowWithArea = optic.matchingRows.find(row => row.area && row.area !== 0);

            return firstRowWithArea ? (
                <tr 
                    key={firstRowWithArea.id} 
                    className={optic.status ? 'status-actualized1' : 'status-no-coordinates1'}
                    onClick={() => handleRowClick(optic)}
                >
                    <td style={{ textShadow: '2px 2px 4px #242424'}}>
                        {optic.highwayLineId}
                        <Button 
                            style={{ marginLeft: '10px', minWidth: '25px', width: '25px', minHeight: '25px', height: '25px' }}
                            onClick={(e) => {
                                e.stopPropagation(); 
                                copyToClipboard(optic.highwayLineId);
                            }}
                        >
                            <FileCopyIcon style={{ color: '#e0920b' }} />
                        </Button>           
                    </td>
                    <td style={{ textShadow: '2px 2px 4px #242424'}}>{firstRowWithArea.canton}</td>
                    <td style={{ textShadow: '2px 2px 4px #242424'}}>{firstRowWithArea.region}</td>
                    <td style={{ textShadow: '2px 2px 4px #242424'}}>{firstRowWithArea.area}</td>
                    <td style={{ textShadow: '2px 2px 4px #242424',  fontSize: "12px"}}>{firstRowWithArea.cableType}</td>
                    <td style={{ textShadow: '2px 2px 4px #242424'}}>{firstRowWithArea.cableName}</td>
                    <td style={{ textShadow: '2px 2px 4px #242424'}}>{firstRowWithArea.lengthCable} м.</td>
                    {/* <td style={{ textShadow: '2px 2px 4px #242424'}}>{firstRowWithArea.street} д.{firstRowWithArea.house} под.{firstRowWithArea.entrance}</td> */}
                 <td
                    style={{
                      maxWidth: '150px',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: 'vertical',
                      whiteSpace: 'normal',
                      textShadow: '2px 2px 4px #242424',
                      padding: '5px',
                    fontSize: "12px"
                    }}  
                  >
                    {
                      firstRowWithArea.streetStart || firstRowWithArea.houseStart || firstRowWithArea.entranceStart
                        ? `${firstRowWithArea.streetStart ?? ''} д.${firstRowWithArea.houseStart ?? ''} под.${firstRowWithArea.entranceStart ?? ''}`
                        : 'нет'
                    }
                  </td>

                 <td
                    style={{
                      maxWidth: '150px',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: 'vertical',
                      whiteSpace: 'normal',
                      textShadow: '2px 2px 4px #242424',
                      padding: '5px',
                      fontSize: "12px"
                    }}
                  >
                    {
                      firstRowWithArea.streetEnd || firstRowWithArea.houseEnd || firstRowWithArea.entranceEnd
                        ? `${firstRowWithArea.streetEnd ?? ''} д.${firstRowWithArea.houseEnd ?? ''} под.${firstRowWithArea.entranceEnd ?? ''}`
                        : 'нет'
                    }
                  </td>

                    <td >
                        {firstRowWithArea.description?.length > 20 
                            ? firstRowWithArea.description.substring(0, 20) + '...' 
                            : firstRowWithArea.description}
                    </td>
                    <td style={{ textShadow: '2px 2px 4px #242424'}}>{firstRowWithArea.authorId}</td>
                    <td style={{ textShadow: '2px 2px 4px #242424'}}>
                        <img src={optic.status ? './ok.png' : './no.png'} alt="status icon"/>
                    </td>
                </tr>
            ) : null;
        })}
                    </tbody>
                </table>
            </div>      
         )} 

                {openVewingModal && selectedCable && (
                   <ModalUpdatingOptic
                    open={openVewingModal} 
                    onClose={() => setOpenVewingModal(false)}
                    context={selectedCable} 
                    houses={houses}
                    user={user}
                   /> 
                )}

                  {/* Snackbar */}
                    <Snackbar
                         anchorOrigin={{
                         vertical: 'bottom',
                         horizontal: 'left',
                         }}
                         open={snackbarOpen}
                         autoHideDuration={3000}
                         onClose={handleCloseSnackbar}
                         message={snackbarMessage}
                         ContentProps={{
                          style: {
                            color: snackbarClass === 'snackbarOk' ? '#ffda62' : '#202020'
                          }
                        }}
                      />            
        </div>
    );
};

export default UpdatingOptic;